<template>
  <div class="c_counter">
    <svg :class="[getClass]" class="c_counter-battery" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <rect width="16" height="10" x="2" y="7" rx="2" ry="2"/>
      <line x1="6" x2="6" y1="11" y2="13" v-if="count > 0"/>
      <line x1="10" x2="10" y1="11" y2="13" v-if="count >= 5"/>
      <line x1="14" x2="14" y1="11" y2="13" v-if="count >= 15"/>
    </svg>
    <span class="c_counter-message">
      {{getMessage}}
    </span>
  </div>
</template>

<script>
export default {
  name: "CustomCountDisplay",
  props: {
    count: {
      type: Number,
      default: () => 0
    }
  },
  computed: {
    getMessage(){
      if(this.count <= 0){
        return 'Нет на складе'
      }else if(this.count === 1){
        return 'Осталось 1шт.'
      }else if(this.count < 5){
        return 'Очень мало'
      }else if(this.count < 15){
        return 'Мало'
      }else{
        return 'Достаточно'
      }
    },
    getClass(){
      if(this.count <= 0){
        return 'c_counter-battery-0'
      }else if(this.count < 5){
        return 'c_counter-battery-1'
      }else if(this.count < 5){
        return 'c_counter-battery-1'
      }else if(this.count < 15){
        return 'c_counter-battery-2'
      }else{
        return 'c_counter-battery-3'
      }
    }
  }
}
</script>

<style scoped>
  .c_counter{
    height: 1.2rem;
    display: flex;
    gap: .2rem;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    font-size: .9rem;
  }

  .c_counter-battery{
    height: 1.6rem;
  }

  .c_counter-battery-3{
    color: var(--success-color);
  }

  .c_counter-battery-2{
    color: var(--warning-color);
  }

  .c_counter-battery-1{
    color: var(--error-color);
  }

  .c_counter-battery-0{
    color: var(--separator-color);
  }

  @media screen and (max-width: 1280px) {

    .c_counter{
      font-size: .8rem;
    }

    .c_counter-battery{
      height: 1.4rem;
    }
  }

  @media screen and (max-width: 1200px) {

    .c_counter{
      font-size: .9rem;
    }

    .c_counter-battery{
      height: 1.6rem;
    }
  }

  @media screen and (max-width: 1100px) {

    .c_counter{
      font-size: .9rem;
    }

    .c_counter-battery{
      height: 1.8rem;
    }
  }

  @media screen and (max-width: 992px) {

    .c_counter{
      font-size: 1rem;
    }

    .c_counter-battery{
      height: 2rem;
    }
  }

  @media screen and (max-width: 768px) {

    .c_counter{
      height: 1rem;
      font-size: 0.8rem;
    }

    .c_counter-battery{
      height: 1.4rem;
    }
  }
</style>